module.exports = __webpack_public_path__ + "assets/download_csv.af0e99c7.svg";